import { ActivitySpinnerWidget, InlineAlertType, InlineAlertWidget, Tooltip, TooltipPosition } from '@tableau/widgets';
import React, { ReactElement } from 'react';
import { connect } from 'react-redux';

import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { MapStateToProps } from '~src/commonInfra/utils/ConnectUtils';
import { IGetSiteEncryptionKeyResult } from '~src/kmsInOnline/serverApi/GetSiteEncryptionKeyRequest';
import { keyNotFoundError } from '~src/settings/general-settings/components/sections/kms-in-online/KMSInOnlineSection';

import { cellStyle, headerStyle, rowStyle, tableStyle, tooltipCellStyle } from '../styles/ExtractEncryptionSettingsStyles';
import { formatDate } from '../utils/ExtractEncrpytionUtils';
import { CMEKEncryptionKeyActionMenu } from './CMEKEncrpytionKeyActionMenu';

export interface CMEKEncrpytionKeyTableProps {
  isLoading: boolean;
  encryptionKey: IGetSiteEncryptionKeyResult;
}

interface ColumnKey {
  name: string;
  width: string;
}

export function getColumnKeys(): ColumnKey[]{
  return [
    {
      name: Messages.extractEncryptionCMEK_KeyID_Header(),
      width: '20%'
    },
    {
      name: Messages.actions(),
      width: '5%'
    },
    {
      name: Messages.extractEncryptionCMEK_RootKeyType_Header(),
      width: '20%'
    },
    {
      name: Messages.extractEncryptionCMEK_KeyVersionID_Header(),
      width: '20%'
    },
    {
      name: Messages.extractEncryptionCMEK_Generated_Header(),
      width: '20%'
    }
  ];
  }

export class CMEKEncryptionKeyTableComponent extends React.PureComponent<CMEKEncrpytionKeyTableProps, {}> {

  public constructor(props: CMEKEncrpytionKeyTableProps) {
    super(props);
  }

  public render() {
    if(this.props.isLoading){
      return(
        <div style={{paddingRight: '50px'}}>
          <table style={{...tableStyle, width: '75%'}}>
            {this.getTableHeaders()}
            </table>
            <div data-tb-test-id style={{textAlign: 'center'}}>
              <ActivitySpinnerWidget style={{textAlign:'center', marginTop: '30px'}} testId='test'></ActivitySpinnerWidget>
            </div>
        </div>
      );
    } else{
      return (
        <div style={{paddingRight: '50px'}}>
          <table style={{...tableStyle, width: '75%'}}>
            {this.getTableHeaders()}
            <tbody>
              <tr style={rowStyle}>
                <td style={cellStyle}>
                  {this.isKeyEmpty() ? Messages.extractEncryptionTOLKeyEmpty() : this.getTooltip(this.props.encryptionKey.keyId)}
                </td>
                <td style={cellStyle}>
                  <CMEKEncryptionKeyActionMenu cmekEncrpytionKey={this.props?.encryptionKey}/>
                </td>
                <td style={cellStyle}>
                  {this.isKeyEmpty() ? '' : this.getTooltip('Salesforce')}
                </td>
                <td style={cellStyle}>
                  {this.getTooltip(this.props?.encryptionKey?.keyVersionId)}
                </td>
                <td style={cellStyle}>
                 {this.getTooltip(formatDate(this.props?.encryptionKey?.keyCreatedDate))}
                </td>
              </tr>
            </tbody>
          </table>
          {this.isKeyEmpty() ? <InlineAlertWidget type={InlineAlertType.Warning} children={Messages.extractEncryptionCMEK_EmptyKeyWarning()} /> :null }
        </div>
      );
    }
  }

  private getTooltip(value: string): ReactElement<Tooltip> {
    return (
      <Tooltip
          position={TooltipPosition.Bottom}
          afterDelay={true}
          tooltipContent={value}
          onlyShowWhenClipped={true}
        >
          <div style={tooltipCellStyle}>{value}</div>
      </Tooltip>
    );
  }

  private getTableHeaders() {
      return (
        <thead>
          <tr style={rowStyle}>
            {getColumnKeys().map((header, index) => (
              <th key={index} style={{ ...headerStyle, width: header.width }}>
                {this.getTooltip(header.name)}
              </th>
            ))}
          </tr>
        </thead>
      );
    }

  private isKeyEmpty(): boolean {
    return keyNotFoundError(this.props.encryptionKey) || this.props.encryptionKey?.errors !== undefined || !this.props.encryptionKey;
 }
}

const mapStateToProps: MapStateToProps<CMEKEncrpytionKeyTableProps> = (state: AppState) => ({
  isLoading: state.extractEncryptionInfo.isFetchingEncryptionKey,
  encryptionKey: state.extractEncryptionInfo.encryptionKey
});

export const CMEKEncryptionKeyTable: React.ComponentClass<{}> =
  connect(mapStateToProps, undefined)(CMEKEncryptionKeyTableComponent);